<template>
  <div class="columns">
    <div class="column is-narrow">
      <div class="user_admin_menu">
        <p v-if="!isInfoPage && !isOrganizator"><span class="dot"></span> <a href="/comission_profile">Личная информация</a></p>
        <!--        <p v-if="isInfoPage"><span class="dot"></span> <a @click.prevent="tab='biografy'">Описание региона</a></p>-->
        <p v-if="isInfoPage"><span class="dot"></span> <a @click.prevent="tab='contact'">Контакты кинокомиссии</a></p>
        <ul>
          <li v-if="!isInfoPage || (isInfoPage && (tabHasUsers('regiser') || tabHasUsers('secondRegiser')))">
            Режиссерская группа
            <ul>
              <li v-if="!isInfoPage || tabHasUsers('regiser')" :class="tab==='regiser' ? 'is-active': ''"><a
                  @click.prevent="tab='regiser'; getData()">Режиссеры</a>
              </li>
              <li v-if="!isInfoPage || tabHasUsers('secondRegiser')" :class="tab==='secondRegiser' ? 'is-active': ''"><a
                  @click.prevent="tab='secondRegiser'; getData()">Вторые
                режиссеры</a></li>
            </ul>
          </li>

          <li v-if="!isInfoPage || (isInfoPage && (tabHasUsers('operator') || tabHasUsers('gafer')))">Операторская
            группа
            <ul>
              <li v-if="!isInfoPage || tabHasUsers('operator')" :class="tab==='operator' ? 'is-active': ''"><a
                  @click.prevent="tab='operator'; getData()">Операторы</a></li>
              <li v-if="!isInfoPage || tabHasUsers('gafer')" :class="tab==='gafer' ? 'is-active': ''"><a
                  @click.prevent="tab='gafer'; getData()">Гаферы</a></li>
            </ul>
          </li>

          <li v-if="!isInfoPage || (isInfoPage && (tabHasUsers('zvykoregiser') || tabHasUsers('soundRegiserAssistent')))">
            Звукорежиссерская группа
            <ul>
              <li v-if="!isInfoPage || tabHasUsers('zvykoregiser')" :class="tab==='zvykoregiser' ? 'is-active': ''"><a
                  @click.prevent="tab='zvykoregiser'; getData()">Звукорежиссеры</a>
              </li>
              <li v-if="!isInfoPage || tabHasUsers('soundRegiserAssistent')"
                  :class="tab==='soundRegiserAssistent' ? 'is-active': ''"><a
                  @click.prevent="tab='soundRegiserAssistent'; getData()">Ассистенты звукорежиссера</a></li>
            </ul>
          </li>

          <li v-if="!isInfoPage || (isInfoPage && (tabHasUsers('producer') || tabHasUsers('location_manager')))">
            Продюсерская группа
            <ul>
              <li v-if="!isInfoPage || tabHasUsers('producer')" :class="tab==='producer' ? 'is-active': ''"><a
                  @click.prevent="tab='producer'; getData()">Продюсеры</a></li>
              <li v-if="!isInfoPage || tabHasUsers('location_manager')"
                  :class="tab==='location_manager' ? 'is-active': ''"><a
                  @click.prevent="tab='location_manager'; getData()">Локейшн-менеджеры</a></li>
            </ul>
          </li>
          <li v-if="!isInfoPage || (isInfoPage && tabHasUsers('dramaturg'))">Группа сценаристов
            <ul>
              <li v-if="!isInfoPage || tabHasUsers('dramaturg')" :class="tab==='dramaturg' ? 'is-active': ''"><a
                  @click.prevent="tab='dramaturg'; getData()">Драматурги</a></li>
            </ul>
          </li>
          <li v-if="!isInfoPage || (isInfoPage && (tabHasUsers('regiser_montazha') || tabHasUsers('montazher')))">
            Монтажно-тонировочная группа
            <ul>
              <li v-if="!isInfoPage || tabHasUsers('regiser_montazha')"
                  :class="tab==='regiser_montazha' ? 'is-active': ''"><a
                  @click.prevent="tab='regiser_montazha'; getData()">Режиссер монтажа</a></li>
              <li v-if="!isInfoPage || tabHasUsers('montazher')" :class="tab==='montazher' ? 'is-active': ''"><a
                  @click.prevent="tab='montazher'; getData()">Монтажер</a></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="column">
      <div style="margin-bottom: 20px;" v-if="(!isInfoPage || mode === 'edit') && tab !== 'contact'">
        <div class="field" style="margin-top: 0; margin-bottom: 10px;">
          <label>{{ select_label }}</label>
          <Select
              v-model:value="selected_item"
              size="middle"
              :filter-option="false"
              style="width: 400px"
              show-search
              @change="changeRegiser"
              @search="fetchSingers"
              :not-found-content="fetching ? undefined : null"
          >
            <SelectOption :class="option.public_account ? '' : 'notShowContactInfo'"
                          v-for="(option, index) in users_options" :label="option.label" :value="option.value"
                          :key="index">
              {{ option.label }} - {{ option.email }} - {{ option.roles }}
            </SelectOption>
            <template v-if="fetching" #notFoundContent>
              <Spin size="small"/>
            </template>
          </Select>
        </div>
        <Button @click="addComissionUser" type="primary">Добавить</Button>
      </div>

      <template v-if="tab === 'biografy'">
        <div v-html="comission.biografy"></div>
      </template>
      <template v-else-if="tab === 'contact'">
        <div v-if="comission" v-html="comission_about_handle"></div>
        <div v-else>Нет данных</div>
      </template>
      <template v-else>
        <template v-if="!loading">
          <div class="comission_table">
            <Table
		            v-if="users && users.length > 0"
                :style="!isInfoPage ? 'margin-top: 30px;': ''"
                :dataSource="users"
                :columns="columns"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'avatar'">
                  <ImageRender
                      class-name="mini_user_avatart"
                      :src="getUserAvatar(record.avatar)">
                  </ImageRender>
                  <!--                            <template>-->
                  <!--&lt;!&ndash;                                <img class="mini_user_avatart" :src="'https://script.moviestart.ru/uploads/images/'+ record.avatar">&ndash;&gt;-->
                  <!--																-->
                  <!--                            </template>-->
                  <!--                            <template v-else>-->
                  <!--                                <img src="https://script.moviestart.ru/images/anonym.png">-->
                  <!--                            </template>-->

                </template>
                <template v-if="column.key === 'fio'">
                  <div style="display: flex; align-items: center">
                    <a :href="'/current-user/'+ record.id + '/part'">
                      {{ record.fio }}
                    </a>
                  </div>
                </template>
                <template v-if="column.key === 'actions'">
                  <a @click.prevent="deleteComissionUser(record.id)">Удалить</a>
                </template>
              </template>
            </Table>
          </div>
        </template>
        <template v-else>
          <div style="margin-top: 30px;">
            <Spin></Spin>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import {Select, SelectOption, Spin, Button, Table} from 'ant-design-vue';
import axios from 'axios';
import ImageRender from "@/components/Base/ImageRender.vue";
import ImageService from "@/services/ImageService";

export default {
  name: 'ComissionComponent',
  data() {
    return {
      tab: 'contact',
      users: [],
      allUsers: [],
      comission: null,
      users_options: [],
      selected_item: '',
      selected_item_id: '',
      fetching: false,
      loading: false,
      delayTimeout: 0,
      columns: []
    }
  },
  components: {
    ImageRender,
    Select,
    Spin,
    SelectOption,
    Button,
    Table,
  },
  mounted() {
    if (this.isInfoPage) {
      this.columns = [
        {
          title: '-',
          dataIndex: 'avatar',
          key: 'avatar',
          width: 70
        },
        {
          title: 'ФИО',
          dataIndex: 'fio',
          key: 'fio',
        }
      ];
    }
    else {
      this.columns = [
        {
          title: '-',
          dataIndex: 'avatar',
          key: 'avatar',
          width: 70
        },
        {
          title: 'ФИО',
          dataIndex: 'fio',
          key: 'fio',
        },
        {
          title: 'Действия',
          key: 'actions',
        },
      ];
      this.tab = 'regiser';
    }

    axios.get('/get_comission/' + window.comissionId).then((data) => {
      this.comission = data.data;
    })

    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      let response;

      if (this.isInfoPage) {
        if (this.allUsers.length === 0) {
          response = await axios.get('/get_comission_users/all/' + window.comissionId, {
            headers: {
              'Accept': 'application/json'
            }
          });
          this.allUsers = response.data;
        }
        this.users = this.currentUsers;
      }
      else {
        let url = '/get_comission_users/' + this.tab;
        if (this.isOrganizator) {
          url += '/' + window.comissionId;
        }
        response = await axios.get(url, {
          headers: {
            'Accept': 'application/json'
          }
        });
        
        
        if (this.isOrganizator) {
          this.allUsers = response.data;
          this.users = this.currentUsers;
        } else {
          this.users = response.data;
        }

        
      }


      this.loading = false;
    },
    fetchSingers(value) {
      const self = this;
      clearTimeout(this.delayTimeout);

      this.delayTimeout = setTimeout(function () {
        self.fetching = true;
        if (value.length > 0) {
          axios.get('/user/getAllUsers/' + value).then((data) => {
            self.users_options = data.data.map((item) => {
              return {
                id: item.id,
                label: item.fio,
                email: item.email,
                roles: item.user_roles,
                value: '/api/users/' + item.id,
                showContactInfo: item.showContactInfo,
                public_account: item.public_account
              }
            });
          })
        }
        self.fetching = false;
      }, 1000); // set the delay time in milliseconds here
    },
    getUserAvatar(avatar) {
      return ImageService.getUserImagePath(avatar);
    },
    changeRegiser(value) {
      const item = this.users_options.find((el) => {
        return el.value === value
      });
      if (!item.public_account) {
        alert('Пользователя нельзя добавить т.к. он не открыл свои персональные данные');
        this.selected_item = null;
        this.selected_item_id = null;
        return;
      }
      this.selected_item = item.label;
      this.selected_item_id = item.id;
    },
    async addComissionUser() {
      if (this.selected_item_id) {
        this.loading = true;
        if (this.isOrganizator) {
          await axios.get('/add_comission_user/' + this.selected_item_id + '/' + this.tab + '/' + window.comissionId);
          this.allUsers = [];
        } else {
          await axios.get('/add_comission_user/' + this.selected_item_id + '/' + this.tab);
        }

        this.selected_item = null;
        this.selected_item_id = null;
        this.getData();
      }
    },
    async deleteComissionUser(id) {
      this.loading = true;
      if (this.isOrganizator) {
        await axios.get('/delete_comission_user/' + id + '/' + this.tab + '/' + window.comissionId);
      } else {
        await axios.get('/delete_comission_user/' + id + '/' + this.tab);
      }
      this.getData();
    },
    tabHasUsers(tab) {
      return this.allUsers[tab]?.length > 0;
    }
  },
  computed: {
    comission_about_handle() {
      if (this.comission?.about === undefined || this.comission?.about === null) {
        return 'Нет данных';
      }
      return this.comission.about.replaceAll('src="uploads', 'src="/uploads');
    },
    isInfoPage() {
      // Есть роут для редактирования самими комиссиями своей анкеты /comission_members
      // comission_info/7232 (comission_members_info) - это для инфо просмотра для всех
      if (this.mode === 'edit') {
        return false;
      }
      return window.currentPage === 'comission_members_info';
    },
    mode() {
      return window.mode;
    },
    isOrganizator() {
      return this.currentUserId === '2413';
    },
    currentUserId() {
      return window.currentUserId
    },
    currentUsers() {
      let res = this.allUsers[this.tab];
      if (res !== undefined && res.length > 0) {
        res.reverse();
      }
      return res;
    },
    select_label() {
      let res = '';
      if (this.tab === 'regiser') {
        res = 'Добавить режисера';
      } else if (this.tab === 'operator') {
        res = 'Добавить оператора';
      } else if (this.tab === 'zvykoregiser') {
        res = 'Добавить звукорежисера';
      } else if (this.tab === 'producer') {
        res = 'Добавить продюсера';
      } else if (this.tab === 'location_manager') {
        res = 'Добавить локэйшен-менеджера';
      } else if (this.tab === 'secondRegiser') {
        res = 'Добавить второго режиссера';
      } else if (this.tab === 'gafer') {
        res = 'Добавить гафера';
      } else if (this.tab === 'soundRegiserAssistent') {
        res = 'Добавить ассистента звукорежиссера';
      } else if (this.tab === 'dramaturg') {
        res = 'Добавить драматурга';
      } else if (this.tab === 'regiser_montazha') {
        res = 'Добавить режиссер монтажа';
      } else if (this.tab === 'montazher') {
        res = 'Добавить монтажера';
      }
      return res;
    }
  }
}
</script>
<style>
.notShowContactInfo {
    background: #ccc;
}

.mini_user_avatart {
    width: 60px;
    height: 60px;
    overflow: hidden;
    max-width: initial;
    border-radius: 50%;
}

.ant-pagination-prev {
    margin-top: 4px;
}

a, .user_admin_menu a:hover, .user_admin_menu li.is-active a {
    color: #F69F22;
}
</style>